<template>
  <div class="prev-next-nav" @click="hideMenu">
      <router-link v-if="prevPageRouterArray" class="prev-next-nav__link prev-next-nav__link--prev" :to="prevPageRouterArray">
        {{translations['prev']}}
      </router-link>
      <router-link v-if="nextPageRouterArray" class="prev-next-nav__link prev-next-nav__link--next" :to="nextPageRouterArray">
        {{translations['next']}}
      </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'prev-next-nav',
  computed: {
    ...mapGetters(['translations', 'nextPageRouterArray', 'prevPageRouterArray']),
  },
  data() {
    return {
      touch: false,
      showMenu: false,
    };
  },
  mounted() {
    document.addEventListener('scroll', () => {
      if (window.innerHeight - this.$el.getBoundingClientRect().top > 90) {
        document.body.classList.add('menu-show');
      } else {
        document.body.classList.remove('menu-show');
      }
    });
  },
  methods: {
    showMenuF() {
      this.showMenu = true;
      document.body.classList.add('menu-show');
    },
    hideMenu() {
      this.showMenu = false;
      document.body.classList.remove('menu-show');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../scss/helpers';

.prev-next-nav {
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  background: $c_primary;
  padding: 0 40px;
  z-index: 1;
  position: relative;


  &__link {
    color: $c_white;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    padding: 12px 0;
    text-decoration: none;

    &--prev::before,
    &--next::after {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      box-sizing: border-box;
      transform: rotate(45deg);
    }

    &--prev::before {
      border-bottom: 1px solid $c_white;
      border-left: 1px solid $c_white;
    }

    &--next::after {
      border-top: 1px solid $c_white;
      border-right: 1px solid $c_white;
    }


    &--next {
      float: right;
    }

    &--prev {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrevNextNav.vue